import { ButtonLink } from './Button';
import { Container } from './Section';
import { Icon } from '../lib/icons';

type PageHeroProps = {
  eyebrow: string;
  title: string;
  body: string;
  primary?: { label: string; href: string };
  secondary?: { label: string; href: string };
  highlights?: string[];
};

export function PageHero({ eyebrow, title, body, primary, secondary, highlights }: PageHeroProps) {
  return (
    <section className="relative overflow-hidden border-b border-brand-border bg-white">
      <div className="absolute inset-0 engineering-grid opacity-60" />
      <div className="absolute right-0 top-0 h-full w-1/2 bg-gradient-to-l from-brand-background to-transparent" />
      <Container className="relative py-20 sm:py-24">
        <div className="max-w-4xl">
          <p className="mb-4 text-sm font-extrabold uppercase tracking-[0.14em] text-brand-teal">{eyebrow}</p>
          <h1 className="font-display text-5xl leading-[1.05] text-brand-dark sm:text-6xl lg:text-7xl">{title}</h1>
          <p className="mt-6 max-w-3xl text-lg leading-8 text-brand-muted">{body}</p>
          {(primary || secondary) && (
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              {primary ? <ButtonLink to={primary.href}>{primary.label}</ButtonLink> : null}
              {secondary ? (
                <ButtonLink to={secondary.href} variant="secondary">
                  {secondary.label}
                </ButtonLink>
              ) : null}
            </div>
          )}
          {highlights?.length ? (
            <div className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
              {highlights.map((item) => (
                <div key={item} className="flex items-center gap-3 rounded-md border border-brand-border bg-white/90 p-4 shadow-sm">
                  <Icon name="check" className="h-5 w-5 shrink-0 text-brand-teal" />
                  <span className="text-sm font-bold text-brand-dark">{item}</span>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </Container>
    </section>
  );
}
